export const followingSidebar = ({
  sidebar,
  sidebarInnerSelector = '.following-sidebar-inner',
  isHeaderCalc = false,
  gap = 130,
  topGap = gap,
  bottomGap = gap,
}) => {
  const sidebarInner = sidebar.querySelector(sidebarInnerSelector);
  if (!sidebarInner) return;

  const header = document.querySelector('header');
  
  let lastScrollY = window.scrollY;

  // Убираем любые старые transform'ы, которые могли остаться
  sidebarInner.style.transform = 'none';
  sidebarInner.style.willChange = 'auto';

  function onScroll() {
    const scrollY = window.scrollY;
    const delta = scrollY - lastScrollY;
    lastScrollY = scrollY;

    if (delta === 0) return;

    const headerHeight = isHeaderCalc && header ? header.offsetHeight : 0;
    const topLimit = headerHeight + topGap;
    const bottomLimit = bottomGap;

    const innerH = sidebarInner.offsetHeight;
    const viewportH = window.innerHeight;

    // Если сайдбар меньше вьюпорта — он работает как обычный залипающий хедер
    if (innerH <= viewportH - topLimit - bottomLimit) {
      sidebarInner.style.position = 'sticky';
      sidebarInner.style.top = `${topLimit}px`;
      return;
    }

    const rect = sidebarInner.getBoundingClientRect();
    const parentRect = sidebar.getBoundingClientRect();
    
    const isScrollingDown = delta > 0;
    
    // Вычисляем точный текущий отступ от верха родительского контейнера
    const currentTopOffset = rect.top - parentRect.top; 
    
    // Вычисляем необходимые значения top для CSS position: sticky
    const stickyBottomTop = viewportH - innerH - bottomLimit;
    const stickyTopTop = topLimit;

    if (isScrollingDown) {
      // При скролле ВНИЗ мы хотим, чтобы сайдбар залип снизу, когда мы докрутим до его конца
      if (rect.bottom <= viewportH - bottomLimit) {
        sidebarInner.style.position = 'sticky';
        sidebarInner.style.top = `${stickyBottomTop}px`;
      } else if (
        sidebarInner.style.position === 'sticky' && 
        sidebarInner.style.top === `${stickyTopTop}px`
      ) {
        // Мы изменили направление скролла (раньше скроллили вверх и залипли сверху)
        // Замораживаем сайдбар на его текущем месте через relative
        sidebarInner.style.position = 'relative';
        sidebarInner.style.top = `${currentTopOffset}px`;
      }
    } else {
      // При скролле ВВЕРХ мы хотим, чтобы сайдбар залип сверху, когда мы докрутим до его начала
      if (rect.top >= topLimit) {
        sidebarInner.style.position = 'sticky';
        sidebarInner.style.top = `${stickyTopTop}px`;
      } else if (
        sidebarInner.style.position === 'sticky' && 
        sidebarInner.style.top === `${stickyBottomTop}px`
      ) {
        // Мы изменили направление скролла (раньше скроллили вниз и залипли снизу)
        // Замораживаем сайдбар на его текущем месте через relative
        sidebarInner.style.position = 'relative';
        sidebarInner.style.top = `${currentTopOffset}px`;
      }
    }
  }

  function onResize() {
    sidebarInner.style.position = 'relative';
    sidebarInner.style.top = '0px';
    lastScrollY = window.scrollY;
    onScroll();
  }

  // ResizeObserver отлично справляется с ситуацией, когда догружаются картинки или шрифты
  const ro = new ResizeObserver(() => {
    onResize();
  });
  ro.observe(sidebar);
  ro.observe(sidebarInner);

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  
  onResize();
};
